module.exports = __webpack_public_path__ + "static/media/Business-Cody-Hendry.561d5859.m4v";